export default __webpack_public_path__ + "3cc50afbc9e516f0390d8350ee9b4b06.pdf";